/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Retry_ErrorInputs */

const vi_print_admin_retry_error = /** @type {(inputs: Print_Admin_Retry_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In lại thất bại`)
};

/**

* @param {Print_Admin_Retry_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_retry_error = /** @type {((inputs?: Print_Admin_Retry_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Retry_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_retry_error(inputs)
});